module.exports = __webpack_public_path__ + "static/portfolio-2-0b3d1802e6bccf512d9f550886d2d0ef.jpg";